<template>
  <header>
    <div class="login">
      <div style="margin-top: 60%" class="handset ml-20 mr-20 flex jc-sb pb-5">
        <input
          v-model="amount"
          class="f14"
          type="number"
          placeholder="请输入提现金额"
        />
      </div>
      <button @click="OutsideWithdrawApply" class="butt ml-20 mr-20 fff">提现</button>
    </div>
    <van-dialog v-model="showId" :show-confirm-button="false">
      <div style="text-align: center; margin-top: 0.5rem"></div>
      <div style="text-align: center; line-height: 1.3rem; font-size: 0.55rem">
        实名认证
      </div>
      <div
        style="
          color: #0f81e3;
          text-align: center;
          font-size: 0.35rem;
          margin-bottom: 0.5rem;
        "
      >
        后期提现账户姓名需于本次实名认证相符
      </div>
      <div style="padding: 0 0.3rem">
        <van-field
          style="font-size: 0.42rem"
          label-class="label"
          v-model="username"
          label="本人姓名"
          placeholder="请输入本人姓名"
        />
        <van-field
          style="font-size: 0.42rem"
          label-class="label"
          v-model="idNo"
          label="身份证号"
          placeholder="请输入本人身份证号"
        />
        <van-field
          style="font-size: 0.42rem"
          label-class="label"
          v-model="phone"
          label="手机号"
          placeholder="请输入本人手机号"
        />
        <van-field
          style="font-size: 0.42rem; height: 0; padding: 0; overflow: hidden"
        />
      </div>
      <div>
        <div
          @click="UserRealName"
          style="
            background: #1e88e5;
            color: #fff;
            text-align: center;
            width: 80%;
            margin: 1rem auto;
            line-height: 1.2rem;
            border-radius: 0.2rem;
          "
        >
          立即认证
        </div>
      </div>
    </van-dialog>
  </header>
</template>

<script>
import { api } from "../../biz/api";
import Vue from "vue";
import { Dialog } from "vant";
import VueCookies from "vue-cookies";

Vue.use(VueCookies);
// 全局注册
Vue.use(Dialog);
export default {
  data() {
    return {
      showId: false,
      amount: "",
      username: "",
      idNo: "",
      phone: "",
    };
  },
  mounted() {
    api.Login(this.getQueryVariable("code")).then((res) => {
      if (res.body.status == 1) {
        this.$cookies.set("outside_token", res.body.data.token);

        if (res.body.data.state == 2) {
          // console.log(res.body.data.state);
          this.showId = true;
        }
      }
    });
  },
  methods: {
    OutsideWithdrawApply() {
      api.OutsideWithdrawApply({ amount: this.amount }).then((res) => {
        if (res.body.status == 1) {
          alert(res.body.message);
          this.$router.push({
            path: "/OutsideWithdrawQueryList",
          });
        }
      });
    },
    UserRealName() {
      if (this.idNo && this.username && this.phone) {
        api
          .UserRealName({
            idNo: this.idNo,
            username: this.username,
            phone: this.phone,
          })
          .then((res) => {
            if (res.body.status == 1) {
              alert("认证成功");
              this.showId = false;
            }
          });
      } else {
        alert("请正确填写信息");
      }
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return null;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../login/login.less";
.logo {
  overflow: hidden;
  font-size: 100px !important;
  background: #fff;
  margin-bottom: 150px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>

